export default __webpack_public_path__ + "static/media/NR300.9a8a12ca.jpg";